import { PageFilter } from '../state/app';
import { buildUrlSearchParams } from '../utils/apiRequestUtil';
import axios from '../utils/axios';

const baseUrl = `/api/subtaskTypes`;

export const fetchSubtaskTypeList = async ({
  filters,
  paging,
}: {
  filters: unknown;
  paging: PageFilter;
}) => {
  const params = buildUrlSearchParams(filters, paging);

  const requestUrl = `${baseUrl}`;
  return await axios.get(`${requestUrl}?${params.toString()}`);
};
